@if (icon) {
  <div class="icon">
    <nx-icon [name]="icon"></nx-icon>
  </div>
}
<p>{{ label }}</p>
